import type { QuoteRate, RateQuoteResponse } from "@/lib/api/types";

export const ROSSI_CARRIER_NAME = "Rossi";
export const ROSSI_CARRIER_CODE = "ROSSI";
export const ROSSI_API_CARRIER_CODE = "RSSI";
export const ROSSI_PREVIEW_STATUS = "quote_only";
export const ROSSI_PREVIEW_ID_PREFIX = "rossi-preview";

export function isRossiPreviewRate(rate: QuoteRate): boolean {
  const carrierCode = rate.carrierCode.trim().toUpperCase();
  return (
    (carrierCode === ROSSI_CARRIER_CODE || carrierCode === ROSSI_API_CARRIER_CODE) &&
    rate.status === ROSSI_PREVIEW_STATUS
  );
}

export function isRossiPreviewQuote(quote: RateQuoteResponse | null | undefined): boolean {
  if (!quote) return false;
  return quote.id.startsWith(ROSSI_PREVIEW_ID_PREFIX) || (quote.rates.length > 0 && quote.rates.every(isRossiPreviewRate));
}
